import apiClient from '@/clients/apiClient';

// Loan Products
export const getLoanProducts = (
  page = 1,
  itemsPerPage = 10,
  search = '',
  sortBy = '',
  orderBy = ''
) =>
  apiClient.get(
    `loan-products?page=${page}&itemsPerPage=${itemsPerPage}&search=${search}&sortBy=${sortBy}&orderBy=${orderBy}`
  );

export const createLoanProduct = (data) => apiClient.post('loan-products', data);

export const getLoanProductById = (id) => apiClient.get(`loan-products/${id}`);

export const updateLoanProduct = (id, data) => apiClient.put(`loan-products/${id}`, data);

export const updateLoanProductFees = (id, data) =>
  apiClient.put(`loan-products/${id}/fees`, data);

export const updateLoanProductDocuments = (id, data) =>
  apiClient.put(`loan-products/${id}/documents`, data);

export const updateLoanProductCreditPolicies = (id, data) =>
  apiClient.put(`loan-products/${id}/credit-policies`, data);

export const getActiveLoanProducts = () => apiClient.get('loan-products/active');

// Credit Policies
export const createCreditPolicy = (data) => apiClient.post('credit-policies', data);

export const getCreditPolicies = (
  page = 1,
  itemsPerPage = 10,
  search = '',
  sortBy = '',
  orderBy = ''
) =>
  apiClient.get(
    `credit-policies?page=${page}&itemsPerPage=${itemsPerPage}&search=${search}&sortBy=${sortBy}&orderBy=${orderBy}`
  );

export const getCreditPolicyById = (id) => apiClient.get(`credit-policies/${id}`);

export const updateCreditPolicy = (id, data) => apiClient.put(`credit-policies/${id}`, data);

export const getCreditPolicyUserInputs = (productId) =>
  apiClient.get(`loan-products/${productId}/credit-policies/user-inputs`);

// Policy Parameters
export const getPolicyParameters = (
  page = 1,
  pageSize = 10,
  search = '',
  sortBy = '',
  orderBy = ''
) =>
  apiClient.get(
    `policy-parameters?page=${page}&pageSize=${pageSize}&search=${search}&sortBy=${sortBy}&orderBy=${orderBy}`
  );

export const createPolicyParameter = (data) => apiClient.post('policy-parameters', data);

export const getPolicyParameterById = (id) => apiClient.get(`policy-parameters/${id}`);

export const updatePolicyParameter = (id, data) =>
  apiClient.put(`policy-parameters/${id}`, data);

// loan appraisals
export const getLoanAppraisalById = (id) => apiClient.get(`loan-appraisals/${id}`);

export const getLoanAppraisalsSummary = (loanRequestId) =>
  apiClient.get(`loan-appraisals/${loanRequestId}/summary`);

export const createLoanAppraisal = (data) => apiClient.post('loan-appraisals', data);

export const getBankStatementAnalysisByLoanRequestId = (loanRequestId) =>
  apiClient.get(`loan-appraisals/${loanRequestId}/bank-statement-analysis`);

// loan request
export const createLoanRequest = (data) =>
  apiClient.post('loan-automation/loan-requests', data);

//bank statement analysis
export const getBankStatementAnalysisById = (id) =>
  apiClient.get(`bank-statement-analysis/${id}`);

// Approval Workflows
export const getApprovalWorkflows = (
  page = 1,
  itemsPerPage = 10,
  search = '',
  sortBy = '',
  orderBy = ''
) =>
  apiClient.get(
    `approval-workflows?page=${page}&itemsPerPage=${itemsPerPage}&search=${search}&sortBy=${sortBy}&orderBy=${orderBy}`
  );

export const createApprovalWorkflow = (data) =>
  apiClient.post('approval-workflows/complete', data);

export const updateApprovalWorkflow = (id, data) =>
  apiClient.put(`approval-workflows/${id}/complete`, data);

export const getApprovalWorkflowById = (id) =>
  apiClient.get(`approval-workflows/${id}/detailed`);

// Credit Analysis Settings
export const updateCreditAnalysisSettings = (loanProductId, data) =>
  apiClient.put(`credit-analysis/settings/loan-product/${loanProductId}`, data);

// Workflow Mappings
export const getWorkflowMappings = (loanProductId) =>
  apiClient.get(`loan-products/${loanProductId}/workflow-mappings`);

export const createWorkflowMapping = (loanProductId, data) =>
  apiClient.post(`loan-products/${loanProductId}/workflow-mappings`, data);

export const updateWorkflowMapping = (loanProductId, workflowId, data) =>
  apiClient.put(`loan-products/${loanProductId}/workflow-mappings/${workflowId}`, data);

export const deleteWorkflowMapping = (loanProductId, workflowId) =>
  apiClient.delete(`loan-products/${loanProductId}/workflow-mappings/${workflowId}`);

// Credit Report
export const getDetailedCreditReport = (loanRequestId) =>
  apiClient.get(`credit-analysis/detailed-credit-report/${loanRequestId}`, {
    responseType: 'blob',
  });

// Loan Approvals
export const getLoanApprovalStatus = (externalId) =>
  apiClient.get(`loan-approvals/${externalId}/status`);

export const processLoanApprovalStepAction = (externalId, stepId, data) =>
  apiClient.post(`loan-approvals/${externalId}/steps/${stepId}/action`, data);

export const retryLoanApprovalStep = (externalId, stepId) =>
  apiClient.post(`loan-approvals/${externalId}/steps/${stepId}/retry`, {});

export const overrideLoanApprovalStep = (externalId, stepId, overriddenBy, reason) =>
  apiClient.post(`loan-approvals/${externalId}/steps/${stepId}/override`, null, {
    params: { overriddenBy, reason },
  });
